import { React, useState, useEffect, useRef } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';
import SubtaskObject from '@atlaskit/object/subtask';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  
  PopoverBody,
  PopoverTrigger,
  PopoverContent,
  
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Select,
  Portal
} from '@chakra-ui/react';
import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CornerDownRight } from 'lucide-react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
// import Tasksubtasktable from '../Board/Tasksubtasktable';
import { CornerDownLeft } from 'lucide-react';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import dayjs from 'dayjs';
import { SquareCheck } from 'lucide-react';
import {
  ThunderboltOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import {

  Dropdown,

} from 'antd';


import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
// import SubTaskModal from './SubTaskModal';
import UserAvatar from '../../../../components/userAvatar/index';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import SkeletonWithLoaders from 'components/common/Spinner';
import TaskmodalActivity from '../Board/TaskmodalActivity';
import Timelinesubtasktable from './Timelinesubtasktable';
import Timelinesubtaskmodal from './Timelinesubtaskmodal';
import { setTimelineEpicList } from 'store/actions';

import { AttachmentProvider } from '../attachments/AttachmentProvider';
import AttachmentMenuItem from '../attachments/AttachmentMenuItem';
import AttachmentList from './attachment/AttachmentList';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

import ShareWorkItemModal from '../share/ShareWorkItemModal';
import LogWork from '../Board/LogWork';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

const TimelineTaskmodal = ({
  isOpen,
  onClose,
  task,
  projectId,
  fetchData,
  openSubtaskModal,
  openepicmodal,
  selectedEpicobj,
}) => {
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const quillRef = useRef(null);
  const [isEditingTitle, setIsEditingTitle] = useState(false);

  const [reloadSubtasks, setReloadSubtasks] = useState(0);

  const [attachments, setAttachments] = useState([]);

  const [isShareOpen, setIsShareOpen] = useState(false); // share modal state

  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [taskdata, setTaskData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [mentionPosition, setMentionPosition] = useState({ top: 0, left: 0 });
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [childTasks, setChildTasks] = useState([]);
  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  //   const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');

  const [epicList, setEpicList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleReplies, setVisibleReplies] = useState({});
  const [selectedparent, setSelectedParent] = useState(null);
  const [editingText, setEditingText] = useState('');
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  const [panelOpen, setPanelOpen] = useState(isOpen);
  const [refreshKey, setRefreshKey] = useState(0);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const [localIssueType, setLocalIssueType] = useState(
    taskdata?.issue_type_id || task?.issue_type_id
  );

  const [issuePopoverOpen, setIssuePopoverOpen] = useState(false);

  // const [panelWidth, setPanelWidth] = useState(600);
  // start width in px
  const panelRef = useRef(null);

  const EpicList = useSelector((state) => state?.Authentication?.Epiclist);
  const issueType = task?.data?.issue_name;

  const dispatch = useDispatch();

  const [storyPoints, setStoryPoints] = useState('');
  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );
  const statusList = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );
  const timelinefilteredreqbody = useSelector(
    (state) => state?.Authentication?.timelinefilteredreqbody,
  );
  const isFilteredApplied = useSelector(
    (state) => state?.Authentication?.timelinefilter,
  );

  const roleId = Number(Cookies.get('task-role-id'));
  useEffect(() => {
    setPanelOpen(isOpen);
  }, [isOpen]);

  // ---- PANEL WIDTH CONSTANTS ----
  const MIN_WIDTH = 200; // never smaller than this
  const MAX_SCREEN_RATIO = 0.45; // 55% of screen width

  // Right panel max width should leave some space
  const getMaxWidth = () =>
    Math.min(window.innerWidth * MAX_SCREEN_RATIO, window.innerWidth - 200);

  // ---- STATE ----
  const [panelWidth, setPanelWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  // ---- RESIZE REFS ----
  const isResizing = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  // ---- MOUSE DOWN ----
  const onMouseDown = (e) => {
    isResizing.current = true;
    startX.current = e.clientX;
    startWidth.current = panelWidth;

    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  // ---- MOUSE MOVE ----
  const onMouseMove = (e) => {
    if (!isResizing.current) return;

    const dx = startX.current - e.clientX; // drag left => grow
    let newWidth = startWidth.current + dx;

    newWidth = Math.min(Math.max(newWidth, MIN_WIDTH), getMaxWidth());

    setPanelWidth(newWidth);
  };

  const handleSaveLink = (data) => {
  
    setRefreshLinks(prev => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };


  const fetchFilteredData = async () => {
    try {
      const response = await httpInjectorService.timelinefilterDetails(
        timelinefilteredreqbody,
      );

      if (response.status === 'success' && response.data?.epics) {
        const epicData = response?.data.epics || [];
        dispatch(
          setTimelineEpicList(
            response.status === 'success' ? response.data?.epics : [],
          ),
        );
      } else {
      }
    } catch (error) {
      throw error;
    } finally {
      // setLoading(false);
    }
  };

  // ---- MOUSE UP ----
  const onMouseUp = () => {
    isResizing.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  // ---- UPDATE WIDTH ON SCREEN RESIZE ----
  useEffect(() => {
    const onResize = () => {
      setPanelWidth((prev) => Math.min(prev, getMaxWidth()));
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  // To store tagged usernames & ids

  const handleCloseWithSave = () => {
    handleTaskUpdate();
    handleAddLabel();
   

    onClose();
  };

  const IssueIcon = ({ type }) => {
    const style = { flexShrink: 0 };

    switch (type) {
      case 'TASK':
        return <TaskObject size="medium" style={style} />;

      case 'STORY':
        return <StoryObject size="medium" style={style} />;

      case 'BUG':
        return <BugObject size="medium" style={style} />;

      default:
        return <TaskObject size="medium" style={style} />;
    }
  };

  const ISSUE_TYPES = [
    {
      id: 1,
      label: 'TASK',
      icon: <TaskObject size="small" />,
    },
    {
      id: 2,
      label: 'STORY',
      icon: <StoryObject size="small" />,
    },
    {
      id: 3,
      label: 'BUG',
      icon: <BugObject size="small" />,
    },
  ];

  const selectedIssue =
    ISSUE_TYPES.find((i) => i.id === localIssueType) ||
    ISSUE_TYPES[0];

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev); // toggle
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(taskdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(taskdata.start_date),
  );

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

  useEffect(() => {
    if (taskdata?.labels) {
      const formatted = taskdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [taskdata]);

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        task_id: task.issue_id,
        sprint_id: task.sprint_id,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      requestBody.labels_id = existingLabelIds; // even if empty []

      const response = await httpInjectorService.createLabel(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const gettaskdata = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: task.issue_id,
      issue_type_id: task.issue_type_id,
    };
    try {
      const response = await httpInjectorService.gettaskdata(reqbody);
      if (response.status === 'success') {
        setTaskData(response.data);
      } else {
        setTaskData({});
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [editedTitle, setEditedTitle] = useState(taskdata?.issue_title || '');
  const currentStatus = newstatus || taskdata.issue_status;
  const { bg, color } = getStatusColors(currentStatus);

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        project_id: taskdata.project_id,
        task_id: taskdata.task_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deletetaskcomment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error deleting comment:', error);
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const saveSubtask = async (subtaskId, updatedFields = {}) => {
    const edited = editableTasks[subtaskId] || {};
    const original = childTasks?.find((t) => t.subtask_id === subtaskId);

    if (!original) {
      return;
    }

    const reqBody = {
      project_id: taskdata?.project_id ? taskdata.project_id : projectId, // or dynamic
      subtask_id: subtaskId,
      title: edited.title !== undefined ? edited.title : original.subtask_title,
      subtask_status: updatedFields.status
        ? updatedFields.status
        : original.status,
      subtask_priority: updatedFields.priority
        ? updatedFields.priority
        : original.priority,
      subtask_assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
    };

    try {
      const response = await httpInjectorService.updateSubtask(reqBody);
      if (response.status === 'success') {
        getsubtaskList();
      }
    } catch (error) {
      throw error;
    }
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: taskdata.project_id,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.edit_comment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };

  const handleOpenSubtask = (subtask) => {
    openSubtaskModal(subtask);
  };

  useEffect(() => {
    gettaskcomments();
  }, []);

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: projectId,
        subtask_ids: [subtaskId],
      };
      let response = await httpInjectorService.delete_subtask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const gettaskcomments = async () => {
    let reqbody = {
      project_id: projectId,
      task_id: task.issue_id,
    };
    try {
      const res = await httpInjectorService.gettaskcomments(reqbody);

      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      throw err;
    }
  };

  const postComment = async (text, parentId = null) => {
    if (!text.trim()) return;

    const taggedUserIds = [
      ...new Set(
        taggedUsers
          .filter((user) => text.includes(`@${user.username}`))
          .map((user) => user.user_id),
      ),
    ];

    const requestBody = {
      project_id: projectId,
      task_id: taskdata.task_id,
      comment_text: text,
      tagged_user_ids: taggedUserIds,
    };

    if (parentId) {
      requestBody.parent_comment_id = parentId;
    }

    try {
      const response = await httpInjectorService.addComments(requestBody);

      if (response.status === 'success') {
        if (parentId) {
          setReplyInput((prev) => ({ ...prev, [parentId]: '' }));
          setActiveReply(null);
        } else {
          setCommentInput('');
        }

        setTaggedUsers([]);
        gettaskcomments();
      } else {
        console.error('Failed to post comment:', response.message || response);
      }
    } catch (err) {
      console.error('Error posting comment:', err);
    }
  };

  useEffect(() => {
    if (taskdata?.epic_id) {
      const found = epicList?.find((epic) => epic.epic_id === taskdata.epic_id);
      if (found) {
        setSelectedParent({ value: found.epic_id, label: found.epic_name });
      }
    }
  }, [taskdata, epicList]);

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = taskdata?.sprint_name || ' ';
        const matchedSprint = options?.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (isOpen && (task?.issue_id || task?.task?.issue_id)) {
      const id = task?.issue_id || task?.issue_id;
      gettaskdata(id);
    }
    getsprintlist();
    getLabelList();
    getEpiclist();
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && taskdata) {
      setDescription(taskdata?.description);
      setDueDate(formatDateInput(taskdata.due_date) || '');
      setStartDate(formatDateInput(taskdata.start_date) || '');
      setStoryPoints(taskdata?.story_points || '');
      if (taskdata?.epic_id && taskdata?.epic_name) {
        setSelectedParent({
          value: taskdata.epic_id,
          label: taskdata.epic_name,
        });
      } else {
        setSelectedParent(null);
      }
    }
  }, [isOpen, taskdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleTaskUpdate = async (emp = {}) => {
   
    const finalBody = {
      issue_id: taskdata.task?.issue_id || taskdata.issue_id,
      issue_type_id:emp?.issue_type_id || taskdata?.issue_type_id ,
      project_id: projectId,
      epic_id: emp?.value || taskdata.epic_id || null,
      sprint_id: selectedSprint?.value || taskdata.sprint_id || null,
      story_points: storyPoints || taskdata.story_points || null,
      assignee_id: emp?.user_id || taskdata.assignee_id || null,
      issue_title: editedTitle || taskdata?.issue_title,
      description: description?.trim() || taskdata.description || '',
      issue_status: emp?.status_name || taskdata.issue_status,
      issue_priority: taskdata.task_priority,
      start_date: startDate || taskdata.start_date,
      due_date: dueDate || taskdata.due_date,
    };

    try {
      const response = await httpInjectorService.Taskedit(finalBody);
      if (response?.status === 'success') {
        gettaskdata();
        fetchData();
      }
    } catch (error) {
      toast.error('Something went wrong.');
    }
  };

  const debouncedUpdate = useCallback(
    debounce(() => handleTaskUpdate(), 400),
    [handleTaskUpdate],
  );

  const justOpenedRef = useRef(true);

  const getEpiclist = async () => {
    const queryParams = `?project_id=${projectId}`;
    try {
      const response = await httpInjectorService.get_epic(queryParams);

      setEpicList(response.data);
    } catch (error) { }
  };

  useEffect(() => {
    if (epicModalOpen) {
      getEpiclist(); // fetch only when modal is opened
    }
  }, [epicModalOpen]);

  const getsubtaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: projectId,
      issue_id: task.issue_id,
    };
    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);
      setChildTasks(response.data);
      // assuming array of { id, title }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const isEditable = [1, 2, 3].includes(roleId);

  useEffect(() => {
    getsubtaskList();
  }, [taskdata?.issue_id]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: taskdata.issue_id,
      issue_type_id: task.issue_type_id,
      issue_type: taskdata?.issue_name,
      title: childTaskTitle || '',
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addSubtask(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        getsubtaskList(); // Refresh list
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      throw error;
    }
  };

  const handleCancel = () => {
    setEditedTitle(taskdata?.issue_title || '');
    setIsEditingTitle(false);
  };

  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  const fetchAttachments = async () => {
    try {
      if (!projectId || !taskdata?.issue_id) {
        setAttachments([]);
        return;
      }
      const payload = {
        project_id: projectId,
        epic_id: taskdata?.epic_id || null,
        epic_key: taskdata?.epic_key || null,
        task_id: taskdata?.task_id || null,
        task_key: task?.task?.task_key || task?.task_key || null,
      };

      const res = await httpInjectorService.getAttachment(payload);

      if (res.status === 'success' && res.data) {
        setAttachments(Array.isArray(res.data) ? res.data : []);
      } else {
        setAttachments([]);
      }
    } catch (error) {
      setAttachments([]);
    }
  };

  const issueTypeContent = (
    <div
      style={{
        minWidth: 140,
        maxHeight: 220,
        overflowY: 'auto',
      }}
    >
      {[
        {
          id: 1,
          label: 'TASK',
          icon: <TaskObject size="medium" />,
        },
        {
          id: 2,
          label: 'STORY',
          icon: <StoryObject size="medium" />,
        },
        {
          id: 3,
          label: 'BUG',
          icon: <BugObject size="medium" />,
        },
      ].map((item) => (
        <div
          key={item.id}
          onClick={() =>
            handleTaskUpdate({
              issue_type_id: item.id,
            })
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minHeight: 34,
            padding: '6px 10px',
            cursor: 'pointer',
            borderRadius: 6,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          {item.icon}
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );

  // delete attachment
  const handleDeleteAttachment = async (id) => {
    setAttachments((prev) => prev.filter((att) => att.attachment_id !== id));

    // Optional backend api call
    await httpInjectorService.deleteAttachment({
      attachment_id: id,
      project_id: projectId,
    });

    toast.success('Attachment removed', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  useEffect(() => {
    if (isOpen && projectId && taskdata && taskdata.issue_id) {
      fetchAttachments();
    }
  }, [isOpen, projectId, taskdata?.issue_id]);

  useEffect(() => {
    if (isOpen && task?.issue_id) {
      setLoading(true);

      const fetchAllData = async () => {
        try {
          await Promise.all([
            gettaskdata(),
            getsprintlist(),
            getLabelList(),
            gettaskcomments(),
            getsubtaskList(),
          ]);
        } catch (error) {
          console.error('Error loading modal data:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchAllData();
    }
  }, [isOpen]);

  const status = taskdata?.subtask_status_count || {};

  const done = parseInt(status?.DONE || 0, 10);

  const total = parseInt(status?.task_count || 0, 10);

  // Calculate % safely
  const donePercent = total > 0 ? (done / total) * 100 : 0;



  // const isStacked = panelWidth < columnThreshold;

  return (
    <div>
      <Box
        ref={panelRef}
        position="fixed"
        top="120px"
        right="0"
        width={`${panelWidth}px`}
        maxWidth="95vw"
        height="calc(100vh - 150px)"
        bg="white"
        boxShadow="lg"
        zIndex="1200"
        display="flex"
        flexDirection="column"
        borderLeft="1px solid #e2e8f0"
        overflow="hidden" // keep outer box non-scrolling; inner mainScroll handles scroll
        sx={{
          boxSizing: 'border-box',
          WebkitOverflowScrolling: 'touch',
          '::-webkit-scrollbar': { width: '8px' },
          '::-webkit-scrollbar-thumb': {
            background: '#CBD5E0',
            borderRadius: '8px',
          },
        }}
      >
        <Flex
          align="center"
          justify="space-between"
          px={6}
          py={3}
          borderBottom="1px solid #e2e8f0"
          flex="0 0 64px"
          minHeight="64px"
          zIndex="6"
          bg="white"
        >
          {/* Left Section: Checkbox + JIRA WorkItem */}
          <Flex align="center" gap={2} mt={5}>
            <Text fontWeight="500" color="black">
              Nubax Pulse WorkItem
            </Text>
          </Flex>

          {/* Right Section: Icons */}
          <Flex align="center" gap={4}>
            {/* Open in new tab icon */}
            {/* <Box
              as="button"
              onClick={() => {
                const url = `/admin/taskBoard/${taskdata.project_id}/taskDetails/${task?.task_id}`;
                window.open(url, '_blank');
              }}
              cursor="pointer"
              _hover={{ color: 'blue.500' }}
              bg="transparent"
              border="none"
            >
              <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
            </Box> */}
            <a
              href={`/admin/taskBoard/${taskdata.project_id}/${taskdata?.issue_type_id}/taskDetails/${task?.issue_id}`}
              rel="noopener noreferrer"
              target="_blank"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
            </a>

            {/* Close icon */}
            <Icon
              as={FiX}
              boxSize={5}
              color="gray.700"
              cursor="pointer"
              _hover={{ color: 'red.500' }}
              onClick={onClose}
            />
          </Flex>
        </Flex>

        <Flex
          align="center"
          justify="space-between"
          px={6}
          py={3}
          borderBottom="1px solid #e2e8f0"
          flex="0 0 64px"
          minHeight="64px"
          zIndex="6"
          bg="white"
        >
        
 <HStack spacing={1} align="center">
  {/* Epic */}
  <HStack spacing={1} align="center">
    <ThunderboltOutlined
      style={{
        color: '#884B9E',
        fontSize: '18px',
      }}
    />

    <Text fontSize="md" color="gray.600" mt="12px">
      {epicList?.find(
        (epic) =>
          epic.epic_id === (selectedEpic || taskdata?.epic_key),
      )?.epic_key || taskdata?.epic_key}
    </Text>

    <Text fontSize="md" color="gray.600" mt="12px">
      /
    </Text>
  </HStack>

  {/* Issue Type */}
  <Popover
    isOpen={issuePopoverOpen}
    onClose={() => setIssuePopoverOpen(false)}
    placement="bottom-start"
  >
    <PopoverTrigger>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setIssuePopoverOpen(!issuePopoverOpen);
        }}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        {selectedIssue.icon}

        <Text fontSize="md" color="gray.600" m={0}>
          {task?.task?.issue_key || task?.issue_key}
        </Text>
      </div>
    </PopoverTrigger>

    <PopoverContent width="140px">
      <PopoverBody p={1}>
        {ISSUE_TYPES.map((item) => (
          <div
            key={item.id}
            onClick={() => {
              setLocalIssueType(item.id);

              handleTaskUpdate({
                issue_type_id: item.id,
              });

              setIssuePopoverOpen(false);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 8px',
              borderRadius: 6,
              cursor: 'pointer',
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </div>
        ))}
      </PopoverBody>
    </PopoverContent>
  </Popover>
</HStack>
        </Flex>

        <Box
          flex="1 1 auto"
          minHeight={0} // critical for flex children to size properly
          overflowY="auto" // <-- single scrollbar lives here
          overflowX="hidden"
          bg="transparent"
        >
          {loading ? (
            <Flex justify="center" align="center" w="100%" h="300px">
              <SkeletonWithLoaders />
            </Flex>
          ) : (
            <div style={{ padding: '15px' }}>
              <Box
                as="section"
                display="flex"
                flexDirection="column"
                width="100%"
                minHeight={0}
              >
                <Box
                  as="section"
                  display="flex"
                  flexDirection="column"
                  width="100%"
                  minHeight={0}
                >
                  <Box mb={4}>
                    {!isEditingTitle ? (
                      // --- Normal Text ---
                      <Text
                        fontSize="2xl"
                        fontWeight="bold"
                        cursor="pointer"
                        onClick={() => {
                          if ([1, 2, 3].includes(roleId)) {
                            setEditedTitle(taskdata?.issue_title);
                            setIsEditingTitle(true);
                          }
                        }}
                      >
                        {editedTitle || taskdata?.issue_title || 'Task Title'}
                      </Text>
                    ) : (
                      // --- Editing Mode ---
                      <Box position="relative" width="100%">
                        <Input
                          value={editedTitle}
                          onChange={(e) => setEditedTitle(e.target.value)}
                          size="lg"
                          fontSize="2xl"
                          fontWeight="bold"
                          autoFocus
                          height="40px"
                          focusBorderColor="gray.300"
                          borderRadius="md"
                        />

                        {/* Wrapper ABSOLUTE but not blocking input */}
                        <HStack
                          spacing={2}
                          position="absolute"
                          right="0"
                          top="100%"
                          mt={1}
                          pointerEvents="none"
                        >
                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={() => {
                              handleTaskUpdate(); // call the update function
                              setIsEditingTitle(false); // exit edit mode
                            }}
                          >
                            <CheckIcon boxSize={4} color="grey" />
                          </Box>

                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={handleCancel}
                          >
                            <CloseIcon boxSize={4} color="grey" />
                          </Box>
                        </HStack>
                      </Box>
                    )}

                    {[1, 2, 3].includes(roleId) && (
                      <AttachmentProvider
                        context={{
                          project_id: projectId,
                          epic_id: taskdata?.epic_id || null,
                          epic_key: taskdata?.epic_key || null,
                          task_id: taskdata?.issue_id || null,
                          task_key:
                            task?.task?.issue_key || task?.issue_key || null,
                        }}
                        onUploaded={fetchAttachments}
                      >
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            icon={<AddIcon />}
                            size="sm"
                            aria-label="Add actions"
                            bg="#f3f4f6"
                            border="1px solid #d1d5db"
                            borderRadius="md"
                            _hover={{ bg: '#e5e7eb' }}
                            _active={{ bg: '#e5e7eb' }}
                            color="gray.700"
                            mt={1}
                            mb={30}
                            position="relative"
                            zIndex={1}
                          />
                          <MenuList zIndex={2}>
                            <MenuItem onClick={() => setShowChildInput(true)}>
                              Create child work item
                            </MenuItem>
                            <MenuItem onClick={handleOpenLinkWorkItem}>
                              Link work Items
                            </MenuItem>

                            <AttachmentMenuItem />

                            <MenuItem
                              onClick={() => {
                                console.log('clicked');
                                setShowWebLink(true);
                              }}
                            >
                              Add web link
                            </MenuItem>
                            <MenuItem
                              onClick={() => console.log('Assign task clicked')}
                            >
                              Page
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                console.log('Add attachment clicked')
                              }
                            >
                              Whiteboard
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </AttachmentProvider>
                    )}
                  </Box>

                  <Box mb={6}>
                    <Text fontWeight="semibold" mb={2}>
                      Description
                    </Text>

                    {!isEditingDescription ? (
                      <Box
                        p={3}
                        border="1px solid #e2e8f0"
                        // borderRadius="8px"
                        minH="60px"
                        bg="white"
                        onClick={() =>
                          [1, 2, 3].includes(roleId) &&
                          setIsEditingDescription(true)
                        }
                        cursor={
                          ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                        }
                      >
                        {description ? (
                          <Box
                            dangerouslySetInnerHTML={{ __html: description }}
                            fontSize="sm"
                          />
                        ) : (
                          <Text color="gray.400" fontSize="sm">
                            Add a description...
                          </Text>
                        )}
                      </Box>
                    ) : (
                      <Box>
                        <ReactQuill
                          theme="snow"
                          value={description}
                          onChange={setDescription}
                          placeholder="Write a description..."
                          modules={{
                            toolbar: [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ color: [] }, { background: [] }],
                              ['link', 'image'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            backgroundColor: 'white',
                            // borderRadius: '8px',
                            minHeight: '140px',
                          }}
                        />
                        <Flex justify="flex-start" mt={1} gap={2}>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            borderRadius="0px"
                            onClick={() => {
                              setIsEditingDescription(false);
                              handleTaskUpdate('description', description); // ✅ Save on Done click
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            borderRadius="0px"
                            onClick={() => setIsEditingDescription(false)}
                          >
                            cancel
                          </Button>
                        </Flex>
                      </Box>
                    )}
                  </Box>
                  {openLinkWorkItem && (
                    <div style={{ marginTop: '16px' }}>
                      <LinkWorkItemInput
                        onCancel={() => setOpenLinkWorkItem(false)}
                        current_item_type={'issue'}
                        current_item_id={taskdata.issue_id}
                        onSuccess={triggerRefresh}
                      />
                    </div>
                  )}
                  {showWebLink && (
                    <WebLink
                      onClose={() => setShowWebLink(false)}
                      onSave={handleSaveLink}
                      work_id={taskdata.issue_id}
                      work_type={'issue'}
                    />
                  )}


                  {/* Attachment upload UI */}
                  <Box mb={6}>
                    {attachments?.length > 0 && (
                      <AttachmentList
                        onDelete={handleDeleteAttachment}
                        attachments={attachments}
                      />
                    )}
                  </Box>

                  <Tabs variant="unstyled">
                    {/* Tabs */}
                    <TabList gap={2}>
                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Subtasks
                      </Tab>

                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Linked Items
                      </Tab>
                    </TabList>

                    {/* Tab Content */}
                    <TabPanels mt={4}>
                      {/* Subtasks */}
                      <TabPanel p={0}>
                        {childTasks?.length > 0 &&
                          [1, 2, 3].includes(roleId) && (
                            <Box mt={6}>
                              <Text fontWeight="semibold" mb={2}>
                                SubTasks
                              </Text>
                              {taskdata?.subtask_status_count && (
                                <Box mb={1}>
                                  <Flex align="center" gap={4}>
                                    {/* Progress Bar */}
                                    <Flex
                                      w="100%"
                                      h="10px"
                                      borderRadius="8px"
                                      overflow="hidden"
                                      bg="#E2E8F0"
                                    >
                                      {(() => {
                                        const counts =
                                          taskdata.subtask_status_count;
                                        const total =
                                          Number(
                                            taskdata?.subtask_status_count
                                              ?.subtask_count,
                                          ) || 1;

                                        // Fixed
                                        const todo = Number(
                                          counts['TO DO'] || 0,
                                        );
                                        const done = Number(
                                          counts['DONE'] || 0,
                                        );

                                        // Dynamic statuses (merged into BLUE)
                                        let blue = 0;
                                        let blueStatusText = [];

                                        Object.keys(counts).forEach((key) => {
                                          if (
                                            key !== 'TO DO' &&
                                            key !== 'DONE' &&
                                            key !== 'subtask_count'
                                          ) {
                                            const c = Number(counts[key] || 0);
                                            blue += c;
                                            blueStatusText.push(`${key}: ${c}`);
                                          }
                                        });

                                        const todoPercent =
                                          (todo / total) * 100;
                                        const bluePercent =
                                          (blue / total) * 100;
                                        const donePercent =
                                          (done / total) * 100;

                                        return (
                                          <>
                                            {/* DONE (green) */}
                                            <Tooltip
                                              label={`DONE: ${done} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${donePercent}%`}
                                                bg="#38A169"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>

                                            {/* BLUE (other statuses) */}
                                            <Tooltip
                                              label={`IN PROGRESS: ${blue} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${bluePercent}%`}
                                                bg="#3182CE"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                            {/* TO DO (grey) */}
                                            <Tooltip
                                              label={`TO DO: ${todo} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${todoPercent}%`}
                                                bg="#A0AEC0"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                          </>
                                        );
                                      })()}
                                    </Flex>

                                    {/* Work Done Percentage */}
                                    <Text fontWeight="600" whiteSpace="nowrap">
                                      Done: {Math.round(donePercent)}%
                                    </Text>
                                  </Flex>
                                </Box>
                              )}

                              <Box
                                borderWidth="1px"
                                borderRadius="md"
                                overflow="hidden"
                                boxShadow="sm"
                              >
                                <Box maxH="300px" overflowY="auto">
                                  <Table size="sm" border="1px solid #E2E8F0">
                                    <Thead
                                      bg="gray.100"
                                      position="sticky"
                                      top={0}
                                      zIndex={0}
                                    >
                                      <Tr>
                                        <Th borderRight="1px solid #E2E8F0"></Th>
                                        <Th
                                          borderRight="1px solid #E2E8F0"
                                          w="300px"
                                        >
                                          Work
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Priority
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Assignee
                                        </Th>
                                        <Th>Status</Th>
                                      </Tr>
                                    </Thead>

                                    <Tbody>
                                      {childTasks?.map((task) => {
                                        const edited =
                                          editableTasks[task.subtask_id] || {};

                                        const assigneeIdToUse =
                                          edited.assignee_id !== undefined
                                            ? edited.assignee_id
                                            : task.assignee_id;

                                        const assigneeObj = assigneeList?.find(
                                          (a) => a.user_id === assigneeIdToUse,
                                        );

                                        const subtaskTitle =
                                          edited.title !== undefined
                                            ? edited.title
                                            : task?.subtask_title;

                                        const selectedStatus =
                                          edited.status ||
                                          task.status ||
                                          'TO DO';

                                        const handleSave = () =>
                                          saveSubtask(task.subtask_id);

                                        return (
                                          <Tr key={task.subtask_id}>
                                            <Td
                                              w="150px"
                                              borderRight="1px solid #E2E8F0"
                                            >
                                              <Box
                                                as="button"
                                                style={{
                                                  color: '#3182ce',
                                                  fontWeight: '500',
                                                  background: 'none',
                                                  border: 'none',
                                                  padding: 0,
                                                  cursor: 'pointer',
                                                }}
                                                onClick={() =>
                                                  openSubtaskModal(task)
                                                }
                                              >
                                                <SubtaskObject
                                                  size={20}
                                                  stroke="#0052CC"
                                                  fill="white"
                                                  strokeWidth={2}
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    lineHeight: 1,
                                                  }}
                                                />
                                                {task.subtask_key}
                                              </Box>
                                            </Td>

                                            {/* Editable title */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="300px"
                                            >
                                              <Tooltip
                                                label={subtaskTitle}
                                                hasArrow
                                                placement="top"
                                                openDelay={300}
                                              >
                                                <Input
                                                  size="sm"
                                                  value={subtaskTitle}
                                                  onChange={(e) =>
                                                    handleEditChange(
                                                      task.subtask_id,
                                                      'title',
                                                      e.target.value,
                                                    )
                                                  }
                                                  onKeyDown={(e) =>
                                                    e.key === 'Enter' &&
                                                    handleSave()
                                                  }
                                                  onBlur={handleSave}
                                                />
                                              </Tooltip>
                                            </Td>

                                            {/* Priority */}
                                            <Td borderRight="1px solid #E2E8F0">
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {edited.priority ||
                                                    task.priority ||
                                                    'Medium'}
                                                </MenuButton>
                                                <MenuList>
                                                  {[
                                                    'Low',
                                                    'Medium',
                                                    'High',
                                                  ].map((priority) => (
                                                    <MenuItem
                                                      key={priority}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.subtask_id,
                                                          'priority',
                                                          priority,
                                                        );
                                                        saveSubtask(
                                                          task.subtask_id,
                                                          {
                                                            priority,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {priority}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Assignee */}
                                            <Td borderRight="1px solid #E2E8F0">
                                              <Menu isLazy>
                                                <Tooltip
                                                  label={
                                                    assigneeObj
                                                      ? assigneeObj.username
                                                      : 'Unassigned'
                                                  }
                                                  hasArrow
                                                  placement="top"
                                                  openDelay={300}
                                                >
                                                  <MenuButton
                                                    as={Button}
                                                    variant="ghost"
                                                    size="sm"
                                                    rightIcon={
                                                      <ChevronDownIcon />
                                                    }
                                                  >
                                                    <Box>
                                                      <UserAvatar
                                                        username={
                                                          assigneeObj
                                                            ? assigneeObj.username
                                                            : 'Unassigned'
                                                        }
                                                        size={24}
                                                      />
                                                    </Box>
                                                  </MenuButton>
                                                </Tooltip>

                                                <MenuList
                                                  maxH="200px"
                                                  overflowY="auto"
                                                  zIndex={1500}
                                                >
                                                  {assigneeList?.map(
                                                    (assignee) => (
                                                      <MenuItem
                                                        key={assignee.user_id}
                                                        onClick={() => {
                                                          handleEditChange(
                                                            task.subtask_id,
                                                            'assignee_id',
                                                            assignee.user_id,
                                                          );
                                                          saveSubtask(
                                                            task.subtask_id,
                                                            {
                                                              assignee_id:
                                                                assignee.user_id,
                                                            },
                                                          );
                                                        }}
                                                      >
                                                        <Tooltip
                                                          label={
                                                            assignee.username
                                                          }
                                                          hasArrow
                                                          placement="right"
                                                          openDelay={300}
                                                        >
                                                          <Flex
                                                            align="center"
                                                            gap="2"
                                                          >
                                                            <UserAvatar
                                                              username={
                                                                assignee.username
                                                              }
                                                              size={24}
                                                            />
                                                            <Text fontSize="sm">
                                                              {
                                                                assignee.username
                                                              }
                                                            </Text>
                                                          </Flex>
                                                        </Tooltip>
                                                      </MenuItem>
                                                    ),
                                                  )}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Status */}
                                            <Td>
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {selectedStatus}
                                                </MenuButton>
                                                <MenuList>
                                                  {statusList?.map((status) => (
                                                    <MenuItem
                                                      key={status.status_name}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.subtask_id,
                                                          'status',
                                                          status.status_name,
                                                        );
                                                        saveSubtask(
                                                          task.subtask_id,
                                                          {
                                                            status:
                                                              status.status_name,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {status.status_name}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>
                                          </Tr>
                                        );
                                      })}
                                    </Tbody>
                                  </Table>
                                </Box>
                              </Box>
                            </Box>
                          )}
                      </TabPanel>

                      {/* Linked Items */}
                      <TabPanel p={0}>
                        <ListLinkedWorkItems
                          item_id={taskdata.issue_id}
                          item_type={'issue'}
                          refreshFlag={refreshLinkedItems}
                        />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>

                  {showChildInput && (
                    <HStack mb={4}>
                      <Text fontWeight="semibold" mb={2}>
                        Subtask
                      </Text>
                      <Input
                        placeholder="What needs to be done?"
                        size="sm"
                        value={childTaskTitle}
                        onChange={(e) => setChildTaskTitle(e.target.value)}
                        onKeyDown={(e) =>
                          e.key === 'Enter' && handleAddSubtask()
                        }
                      />
                      <Button
                        size="sm"
                        colorScheme="blue"
                        borderRadius="0px"
                        onClick={handleAddSubtask}
                      >
                        <CornerDownLeft />
                      </Button>
                      <Button
                        size="sm"
                        borderRadius="0px"
                        onClick={() => setShowChildInput(false)}
                      >
                        Cancel
                      </Button>
                    </HStack>
                  )}

                  {/* Comment Input */}
                </Box>
                <WebLinkList work_id={taskdata.issue_id}
                  work_type={'issue'} refreshFlag={refreshLinks} />



                {/* {!isStacked && (
                  <Box
                    width="6px"
                    flexShrink={0}
                    cursor="ew-resize"
                    bg="transparent"
                    _hover={{ bg: 'rgba(0,0,0,0.06)' }}
                    onMouseDown={onMouseDownInner}
                    position="relative"
                    zIndex="3"
                  >
                    <Box
                      position="absolute"
                      top="50%"
                      left="2px"
                      transform="translateY(-50%)"
                      width="2px"
                      height="48px"
                      bg="gray.300"
                      borderRadius="md"
                    />
                  </Box>
                )} */}
                <Box
                  flexShrink={0}
                  width="100%"
                  p={6}
                  borderTop="1px solid #e2e8f0"
                  bg="gray.50"
                  zIndex="1"
                  marginTop={2}
                >
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Menu isDisabled={!isEditable}>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        size="sm"
                        mb={4}
                        p={0}
                        px={0}
                        minW="fit-content"
                        width="fit-content"
                        height="auto"
                        borderRadius="md"
                        bg={bg} // status background
                        color={color} // text color
                        border="1px solid #ccc"
                        _hover={{ bg }}
                        _active={{ bg }}
                      >
                        <Badge
                          bg="transparent"
                          color={color}
                          fontSize="0.8em"
                          p={1}
                        >
                          {currentStatus}
                        </Badge>
                      </MenuButton>

                      {isEditable && (
                        <MenuList>
                          {statusList.map((status) => {
                            const { bg, color } = getStatusColors(
                              status.status_name,
                            );
                            return (
                              <MenuItem
                                key={status.id}
                                onClick={() => {
                                  handleStatusChange(status.status_name);
                                  handleTaskUpdate(status);
                                }}
                              >
                                <Badge
                                  bg={bg}
                                  color={color}
                                  fontSize="0.75em"
                                  p={1}
                                  borderRadius="md"
                                >
                                  {status.status_name}
                                </Badge>
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      )}
                    </Menu>
                  </Tooltip>

                  <Grid
                    templateColumns="120px 1fr"
                    rowGap={5}
                    columnGap={6}
                    alignItems="start"
                  >
                    <Text fontWeight="semibold">Assignee</Text>
                    <Tooltip
                      label={!isEditable ? 'You do not have permission' : ''}
                    >
                      <Popover
                        isOpen={showEmployeePicker}
                        onClose={() => setShowEmployeePicker(false)}
                      >
                        <Box position="relative" width="fit-content">
                          <PopoverTrigger>
                            <HStack
                              spacing={2}
                              onClick={() =>
                                setShowEmployeePicker(!showEmployeePicker)
                              }
                              cursor="pointer"
                            >
                              {selectedEmployee?.username ||
                                taskdata?.assignee_name ? (
                                <>
                                  <UserAvatar
                                    username={
                                      selectedEmployee?.username ||
                                      taskdata?.assignee_name
                                    }
                                    size={24}
                                  />
                                  <Text fontSize="sm">
                                    {selectedEmployee?.username ||
                                      taskdata?.assignee_name}
                                  </Text>
                                </>
                              ) : (
                                <HStack spacing={1} color="gray.500">
                                  <MdOutlinePerson size={20} />
                                  <Text fontSize="sm">Unassigned</Text>
                                </HStack>
                              )}
                            </HStack>
                          </PopoverTrigger>
                        </Box>
                        {isEditable && (
                          <PopoverContent width="auto">
                            <PopoverBody>
                              {assigneeList?.length > 0 ? (
                                <Box maxH="200px" overflowY="auto">
                                  {assigneeList.map((emp) => (
                                    <Box
                                      key={emp.user_id}
                                      onClick={() => {
                                        setSelectedEmployee(emp);
                                        setShowEmployeePicker(false);
                                        handleTaskUpdate(emp);
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      px={2}
                                      py={1}
                                      borderRadius="md"
                                      cursor="pointer"
                                      bg={
                                        selectedEmployee?.user_id ===
                                          emp.user_id
                                          ? '#e6f4ff'
                                          : 'transparent'
                                      }
                                      _hover={{ bg: '#f1f5f9' }}
                                    >
                                      <UserAvatar
                                        username={emp.username}
                                        size={24}
                                        style={{ marginRight: '8px' }}
                                      />
                                      <Text fontSize="sm">{emp.username}</Text>
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                <Text fontSize="sm" color="gray.500">
                                  No employees found
                                </Text>
                              )}
                            </PopoverBody>
                          </PopoverContent>
                        )}
                      </Popover>
                    </Tooltip>

                    <Text fontWeight="semibold">Labels</Text>
                    {/* <Box w="100%">
                    <CreatableSelect
                      placeholder="Select or create label"
                      isClearable
                      isMulti
                      value={selectedLabel}
                      options={labellist.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                      }))}
                      onChange={(newValue) => setSelectedLabel(newValue || [])}
                      formatCreateLabel={(inputValue) =>
                        `Create new label: "${inputValue}"`
                      }
                    />
                  </Box> */}
                    <Box w="100%">
                      {/* <CreatableSelect
                                    placeholder="Select or create label"
                                    isClearable
                                    isMulti
                                    value={
                          selectedLabel.length > 0
                            ? selectedLabel
                            : (taskdata?.labels || []).map((label) => ({
                                label: label.label_name || label,
                                value: label.label_id || label,
                              }))
                        }
                                    options={labellist.map((label) => ({
                                      label: label.label_name,
                                      value: label.label_id,
                                      __isNew__: false,
                                    }))}
                                    onChange={(newValue) => {
                                      setSelectedLabel(newValue || []);
                                    }}
                                    formatCreateLabel={(inputValue) =>
                                      `Create new label: "${inputValue}"`
                                    }
                                  /> */}

                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        isClearable
                        isMulti
                        placeholder="Select or create label"
                        value={selectedLabel}
                        options={labellist?.map((label) => ({
                          label: label.label_name,
                          value: label.label_id,
                          __isNew__: false,
                        }))}
                        onChange={(newValue) => {
                          const updated = newValue || [];

                          setSelectedLabel(updated);
                          handleAddLabel(updated);
                        }}
                      />
                    </Box>

                    <Text fontWeight="semibold">Parent</Text>
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select Parent"
                      isClearable
                      value={selectedparent}
                      onChange={(selected) => {
                        setSelectedParent(selected);
                        handleTaskUpdate(selected);
                      }}
                      options={epicList?.map((epic) => ({
                        value: epic.epic_id,
                        label: epic.epic_name,
                      }))}
                    />

                    <Text fontWeight="semibold">Due date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={dueDate || taskdata?.formatdue_date}
                      onChange={(e) => setDueDate(e.target.value)}
                      onBlur={handleTaskUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate(); // ✅ Save on Enter
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Start date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onBlur={handleTaskUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Sprint</Text>
                    <Text>
                      {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        placeholder="Select or create sprint"
                        isClearable
                        value={
                          selectedSprint ||
                          sprintOptions?.find(
                            (s) => s.label === taskdata?.sprint_name,
                          ) ||
                          (taskdata?.sprint_name
                            ? {
                              label: taskdata.sprint_name,
                              value: taskdata.sprint_id,
                            }
                            : null)
                        }
                        options={sprintOptions}
                        onChange={(newValue) => {
                          setSelectedSprint(newValue);
                          handleTaskUpdate();
                        }}
                        formatCreateLabel={(inputValue) =>
                          `Create new sprint: "${inputValue}"`
                        }
                      />
                    </Text>

                    <Text fontWeight="semibold">Story points</Text>
                    <Input
                      size="sm"
                      placeholder="Add story points"
                      w="100%"
                      type="number"
                      value={storyPoints}
                      onChange={(e) => setStoryPoints(e.target.value)} // <-- update state
                      onBlur={debouncedUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Development</Text>
                    <VStack align="start" spacing={2}></VStack>

                    <Text fontWeight="semibold">Reporter</Text>
                    <HStack align="center" spacing={2}>
                      <Avatar
                        name={taskdata?.issue_created_by_name || 'Unknown'}
                        size="xs"
                      />
                      <Text fontSize="sm" lineHeight="1">
                        {taskdata?.issue_created_by_name || 'Unknown'}
                      </Text>
                    </HStack>
                  </Grid>
                  <div
                    style={{
                      marginTop: 20,
                      padding: '12px 16px',
                      // border: '1px solid #e6e6e6',
                      borderRadius: 8,
                      // background: '#fff',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Created at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {taskdata?.created_at
                          ? dayjs(taskdata?.created_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                          : 'Unknown'}
                      </Text>
                    </div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Updated at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {taskdata?.updated_at
                          ? dayjs(taskdata?.updated_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                          : 'Unknown'}
                      </Text>
                    </div>
                  </div>
                </Box>



                <Box>
                  <TaskmodalActivity
                    taskDetails={task}
                    taskdata={taskdata}
                    taskID={taskdata.issue_id}
                    projectId={taskdata.project_id}
                    refreshKey={refreshKey}
                  />
                </Box>
              </Box>
            </div>
          )}
          <Box
            onMouseDown={onMouseDown}
            onTouchStart={onMouseDown}
            position="fixed"
            right={`${panelWidth}px`}
            top="0"
            width="6px"
            height="100vh"
            cursor="ew-resize"
            bg="transparent"
            _hover={{ bg: 'rgba(0,0,0,0.05)' }}
            zIndex="2000"
          >
            {/* Center thin line like your old UI */}
            <Box
              position="absolute"
              top="50%"
              left="2px"
              transform="translateY(-50%)"
              width="2px"
              height="44px"
              bg="gray.300"
              borderRadius="md"
            />
          </Box>

          <ShareWorkItemModal
            isOpen={isShareOpen}
            onClose={() => setIsShareOpen(false)}
            issue_id={
              taskdata?.issue_id || taskdata?.task?.issue_id || task.issue_id
            }
            issue_type_id={
              taskdata?.issue_type_id ||
              taskdata?.task?.issue_type_id ||
              task.issue_type_id
            }
            project_id={projectId || taskdata.project_id}
          // epic_id={taskdata?.epic_id}
          />

          <Modal
            isOpen={epicModalOpen}
            onClose={() => setEpicModalOpen(false)}
            isCentered
          >
            <ModalOverlay />
            <ModalContent maxW="700px" minH="300px">
              {' '}
              {/* Increase width here */}
              <ModalHeader>Add Epic</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text mb={3}>
                  Select a parent work item. Work items can only belong to one
                  parent at a time.
                </Text>
                <Select
                  placeholder="Select Parent"
                  value={selectedEpic}
                  onChange={(e) => setSelectedEpic(Number(e.target.value))}
                  mt={3}
                >
                  {epicList?.map((epic) => (
                    <option key={epic.epic_id} value={epic.epic_id}>
                      {epic.epic_name}
                    </option>
                  ))}
                </Select>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    // Replace with API call
                    setEpicModalOpen(false);
                  }}
                >
                  Add
                </Button>
                <Button variant="ghost" onClick={() => setEpicModalOpen(false)}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* {openSubTaskModal && selectedSubtask && (
                  <Timelinesubtaskmodal
                    isOpen={openSubTaskModal}
                    subtaskdetails={selectedSubtask}
                    onClose={handlesubtaskmodal}
                    // taskDetails={taskDetails}
                    assigneeList={assigneeList}
                  />
                )} */}
        </Box>
      </Box>
    </div>
  );
};

export default TimelineTaskmodal;
